const portfolioData = [
    {
        id: 0,
        title: "Meyyotivity",
        image: "/assets/works/meyyotivity.jpg",
        desc: "Meyyotivity is a unisex clothing brand. I designed and implemented the website from concept through deployment, created a custom WordPress Theme, setup WooCommerce, Paystack payment gateway, etc.",
        techStack: "SCSS, Bootstrap, jQuery, PHP, WordPress, WooCommerce",
        links: [
            { text: 'View Site', url: "https://www.meyyotivity.com/", },
        ]
    },
    {
        id: 1,
        title: "FlexEvent",
        image: "/assets/works/flexevent.jpg",
        desc: "FlexEvent is a portfolio website for wedding planners or event management companies. It features an admin dashboard to manage the gallery images, testimonials, services and other contents displayed on the website.",
        techStack: "SCSS, Bootstrap, JavaScript, PHP, Laravel",
        links: [
            { text: 'Demo', url: "http://flexevent.yusufdaudu.tech", },
            { text: 'Admin', url: "http://flexevent.yusufdaudu.tech/admin", },
        ]
    },
    {
        id: 2,
        title: "Florintech Computer College",
        image: "/assets/works/florintechcomputercollege.jpg",
        desc: "Florintech is an I.T training institution. I developed a school management system and implement features like register, view and edit students, generate ID cards, manage payment, etc.",
        techStack: "HTML, CSS, Bootstrap, jQuery, MySQL, PHP",
        links: [
            { text: 'Visit Website', url: "http://admin.florintechcomputercollege.com", },
        ]
    },
    {
        id: 3,
        title: "Photo Gallery",
        image: "/assets/works/photo-gallery-reactjs.jpg",
        desc: "A photo gallery web app created with ReactJs and unsplash images API.",
        techStack: "ReactJs, JavaScript, MaterialUI",
        links: [
            { text: 'Demo', url: "https://dycodes.github.io/photo-gallery-reactjs/", },
            { text: 'GitHub', url: "https://github.com/dyCodes/photo-gallery-reactjs", },
        ]
    },
    {
        id: 4,
        title: "EventPlanner",
        image: "/assets/works/eventplanner.jpg",
        desc: "A single page bootstrap template for wedding planner or event management company.",
        techStack: "HTML, CSS, SCSS, Bootstrap, JavaScript",
        links: [
            { text: 'Demo', url: "https://eventplanner-template.netlify.app/", },
            { text: 'GitHub', url: "https://github.com/dyCodes/EventPlanner", },
        ]
    },
    {
        id: 5,
        title: "My Portfolio",
        image: "/assets/works/portfolio.jpg",
        desc: "A modern personal portfolio website created with ReactJS.",
        techStack: "ReactJS, SCSS, Bootstrap, React Scroll, AOS Library",
        links: [
            { text: 'View Site', url: "https://yusufdaudu.tech/", },
            { text: 'GitHub', url: "https://github.com/dyCodes/portfolio", },
        ]
    },
];

export default portfolioData